const version = "1.8.8";

export default version;
